import { useCallback, useEffect, useState } from 'react';
import { initialFieldDecisions } from './ReviewFields';

export const initialRowDraft = row => ({ fields: Object.fromEntries(Object.entries(initialFieldDecisions(row)).map(([key, value]) => [key, { ...value }])), link: row.ajustes?.vinculacion ? { ...row.ajustes.vinculacion } : null, rules: !!row.ajustes?.reglas_confirmadas, rowRevision: row.revision });
const fieldKey = decision => [decision?.accion || 'confirmar', ['mantener', 'ignorar'].includes(decision?.accion) ? '' : String(decision?.valor ?? ''), decision?.motivo || ''];
const linkKey = link => [link?.accion || 'automatico', link?.asset_id || '', link?.principal ?? '', !!link?.duplicacion_descartada, link?.motivo || ''];
export const hasUnsavedRowChanges = (row, draft) => {
  if (!draft) return false;
  const initial = initialRowDraft(row);
  if (draft.rowRevision !== row.revision) return true;
  const keys = new Set([...Object.keys(initial.fields), ...Object.keys(draft.fields)]);
  return [...keys].some(key => JSON.stringify(fieldKey(initial.fields[key])) !== JSON.stringify(fieldKey(draft.fields[key]))) || JSON.stringify(linkKey(initial.link)) !== JSON.stringify(linkKey(draft.link)) || initial.rules !== draft.rules;
};

export const toggleRowProposals = (row, draft) => {
  const fields = draft.fields;
  const selected = Object.values(fields).every(d => ['confirmar', 'editar'].includes(d.accion));
  if (selected) return { ...draft, restoreFields: fields, fields: Object.fromEntries(Object.entries(fields).map(([key, d]) => [key, { ...d, accion: 'mantener' }])) };
  if (draft.restoreFields) return { ...draft, fields: draft.restoreFields, restoreFields: null };
  return { ...draft, fields: Object.fromEntries(Object.entries(fields).map(([key, d]) => [key, ['confirmar', 'editar'].includes(d.accion) ? d : { accion: 'confirmar', valor: row.propuestas_archivo?.[key] ?? row.incoming?.[key] ?? null, motivo: 'Aceptar propuesta del archivo al confirmar la importación' }])) };
};

export const useReviewDrafts = operationId => {
  const [drafts, setDrafts] = useState({}), [saving, setSaving] = useState({});
  useEffect(() => { setDrafts({}); setSaving({}); }, [operationId]);
  const update = useCallback((row, draft, position) => setDrafts(previous => {
    const next = { ...previous };
    if (!hasUnsavedRowChanges(row, draft)) delete next[row.ordinal];
    else next[row.ordinal] = { ...draft, position: previous[row.ordinal]?.position || position, label: `${row.hoja} · fila ${row.fila}` };
    return next;
  }), []);
  const markSaving = useCallback((ordinal, value) => setSaving(previous => { const next = { ...previous }; if (value) next[ordinal] = true; else delete next[ordinal]; return next; }), []);
  const dirtyCount = Object.keys(drafts).length, savingCount = Object.keys(saving).length;
  useEffect(() => {
    if (!dirtyCount) return;
    const warn = event => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirtyCount]);
  return { drafts, update, markSaving, dirtyCount, savingCount };
};